module.exports = __webpack_public_path__ + "fa-solid-900.svg?37bc7099f6f1ba80236164f22e905837";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fortawesome/fontawesome-free/webfonts/fa-solid-900.svg
// module id = 460
// module chunks = 0